import { render, staticRenderFns } from "./accessArea.vue?vue&type=template&id=1b0f1a33&scoped=true&"
import script from "./accessArea.vue?vue&type=script&lang=js&"
export * from "./accessArea.vue?vue&type=script&lang=js&"
import style0 from "./accessArea.vue?vue&type=style&index=0&id=1b0f1a33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f1a33",
  null
  
)

export default component.exports